import React, { memo, useMemo } from 'react';
import { string, object } from 'prop-types';
import Alert from '@active/react-ui/Alert';
import Locale from '@active/react-utils/i18n/Locale';
import { connectStatusConfigs } from '../config';
import CheckScannerImg from '../../../../shared/imgs/check/scanner.svg';
import CheckDeviceImg from '../../../../shared/imgs/check/device.svg';

const ConnectStatus = ({
  status,
  errorInfo,
}) => {
  const {
    id, icon, type, classes,
  } = useMemo(() => {
    return connectStatusConfigs[status];
  }, [ status ]);

  const { show, text } = errorInfo;

  return <>
    <Alert theme="inline" type={type} className="check-warning">
      <Locale id={id} />
    </Alert>

    { show && <Alert theme="inline" type="danger" className="check-danger">
      <Locale id={text} />
    </Alert>}
    <div className='check-icons-container cui-mg-t-20'>
      <div className="check-icon">
        <img src={CheckScannerImg} className="ic-scanner" alt="check-scanner" />
        <span className={classes}>
          <span className={icon} />
        </span>
        <img src={CheckDeviceImg} className="ic-device" alt="check-device" />
      </div>
    </div>
  </>;
};

ConnectStatus.propTypes = {
  status: string.isRequired,
  errorInfo: object.isRequired,
};

export default memo(ConnectStatus);
